// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Classification_shimmer__cI8_p","animate":"Classification_animate__DhFDD"};